// extracted by mini-css-extract-plugin
export var btn = "J_mB x_s0 x_sK d_bz d_bP d_bD d_dw";
export var full = "J_vW d_w d_H";
export var hoverStyle = "J_mF";
export var zoom = "J_mG";